import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=b46b890a&scoped=true&"
import script from "./quotation.vue?vue&type=script&lang=js&"
export * from "./quotation.vue?vue&type=script&lang=js&"
import style0 from "./quotation.vue?vue&type=style&index=0&id=b46b890a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46b890a",
  null
  
)

export default component.exports